import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect } from 'react-redux-firebase';
import { createSelector } from 'reselect';
import { getIsAdmin, getWishIdsIWillBuy } from 'store/firebase/selectors';
import MyWillBuys from './MyWillBuys';

const mapStateToProps = createSelector(
  getIsAdmin,
  getWishIdsIWillBuy,
  (isAdmin, wishIds) => ({ isAdmin, wishIds })
);

export default compose(
  firebaseConnect([
    'willBuys'
  ]),
  connect(mapStateToProps)
)(MyWillBuys);



// WEBPACK FOOTER //
// ./src/components/MyWillBuys/index.js